import type { ReactNode } from 'react';

export const symbol_azm: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M451-91q-14 14-32.5 6.34Q400-92.31 400-112v-288H112q-19.69 0-27.34-18.5Q77-437 91-451l331-331q8-8 19.28-13 11.28-5 23.72-5h275q24.75 0 42.38 17.62Q800-764.75 800-740v275q0 12.44-5 23.72T782-422L451-91Zm179-509v246l110-110v-276H464L354-630h246q12.75 0 21.38 8.62Q630-612.75 630-600ZM460-430v246l110-110v-276H294L184-460h246q12.75 0 21.38 8.62Q460-442.75 460-430Z"
		/>
	</svg>
);
